import 'css-chunksrc/client/common/resourceAvatar/styles.scss';export default {
  "resourceAvatar": "_resourceAvatar_10g7v_1",
  "virtualResourceAvatar": "_virtualResourceAvatar_10g7v_8"
};